module.exports = __webpack_public_path__ + "static/backrightleaf-f5e5afffbccaad8e6952c9a0acbe905d.png";